import React from "react";
import PropTypes from "prop-types";
import { Grid, Item } from "../ThreeColumn";
import ExhibitionTeaser from "../ExhibitionTeaser";
import { exhibitionShape } from "../shapes";
import Placeholder from "../Teaser/Placeholder";

const List = ({ exhibitions, onArtistPage, isLoading }) => (
  <Grid gap="wide">
    {isLoading && (
      <Placeholder style={{ gridRowStart: exhibitions.length / 3 + 1 }} />
    )}
    {exhibitions.map((exhibition, i) => (
      <Item key={exhibition.id}>
        <ExhibitionTeaser exhibition={exhibition} onArtistPage={onArtistPage} />
      </Item>
    ))}
  </Grid>
);

List.propTypes = {
  exhibitions: PropTypes.arrayOf(PropTypes.shape(exhibitionShape).isRequired),
  isLoading: PropTypes.bool,
  onArtistPage: PropTypes.bool,
};

export default List;
